export const RESPONSES = 'other.responseOptions';
// eslint-disable-next-line no-template-curly-in-string
export const RESPONSES_PILL = '${other.responseOptions}';
